export enum PromoType {
    Text,
    GreenBlock,
}
